import { gql } from '@apollo/client';

export const getProjectOverviewDetailsApi = gql`
	query Project($workspaceId: String!, $projectId: ID!) {
		project(workspaceId: $workspaceId, projectId: $projectId) {
			clientPayments {
				_id
				amount
				description
				isPaid
				paidOn
				dueDate
			}
			deliverables {
				_id
				title
				status
				priority
				cost
				completedAt
				assignedTo {
					id
					name
				}
				dueDate
			}
			hardDrives {
				_id
				qrCode
				category
				isPurchasedByClient
				status
				size
				responsibleUser
				manufacturerId
				manufacturer
			}
			lastEvent {
				_id
				name
				city
				date
				time
				parsedName
			}
			firstEvent {
				_id
				name
				city
				date
				time
				parsedName
			}
			overallInsights {
				clientPayments {
					completed
					total
					overdue
					unscheduled
					upcoming
				}
				deliverables {
					total
					completed
				}
				shoots {
					completed
					total
				}
			}
			title
			quotationPrice
			additionalServices {
				_id
				priceInRupees
				type
			}
			expenses {
				_id
				amount
				type
				billTo
				billDate
				eventId
				currency
			}
		}
	}
`;

export const getOverviewVendorDetailsApi = gql`
	query VendorEventsList($filters: VendorEventsListFiltersInput) {
		vendorEventsList(filters: $filters) {
			data {
				id
				tenantId
				projectId
				name
				projectSlNo
				slNo
				category
				city
				venue
				date
				reportingTime

				durationInHrs

				createdBy
				createdAt
				dateOverlap
				dateTimeOverlap
				expenses {
					_id
					amount
					type
					billTo
					billDate
					currency
				}
				projectTitle

				additionalServices {
					type
				}
				createdFrom
				time
				flagLabel
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			hasPrevPage
			prevPage
			nextPage
		}
	}
`;
